var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAlignRighticon = function SvgAlignRighticon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M14.611 1.757h-.778a.389.389 0 0 0-.389.39v1.166h-7a.778.778 0 0 0-.777.778V7.2c0 .43.348.779.777.779h7v1.555H1.778a.778.778 0 0 0-.778.778v3.111c0 .43.348.778.778.778h11.666v1.166c0 .215.175.39.39.39h.777a.389.389 0 0 0 .389-.39V2.146a.389.389 0 0 0-.389-.389ZM7.222 6.424V4.868h6.222v1.556H7.222ZM2.556 11.09v1.555h10.888V11.09H2.556Z",
    clipRule: "evenodd"
  })));
};
export default SvgAlignRighticon;